import React from "react";
import {useEffect} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {IRPStore} from "../../../app/rp_reducer";
import {gtmApplicationPutAside} from "../../../tracking/google_tag_manager/gtm_application_put_aside";
import {getSentLeadFormValuesFromStorage} from "../../utils/lead/sent_lead_form_values";
import {ApplicationGoodbyeContent, IApplicationGoodbyeContentProps} from "./ApplicationGoodbyeContent";

interface IProps extends IApplicationGoodbyeContentProps {}

export function ApplicationGoodbyeContentModal(props: IProps) {
    const data = useSelector((state: IRPStore) => state.application[props.storeHash]);

    useEffect(() => {
        const sentLeadFormValues = getSentLeadFormValuesFromStorage();

        const areFormValuesAvailable =
            sentLeadFormValues && Boolean(sentLeadFormValues.name) && Boolean(sentLeadFormValues.email) && Boolean(sentLeadFormValues.phone);

        if (data && areFormValuesAvailable) {
            gtmApplicationPutAside(data.vendor?.detail, data.offer?.detail);
        }
    }, []);

    return <ApplicationGoodbyeContent {...props} className={wrapperStyle} />;
}

const wrapperStyle = css({
    md: {
        width: "896px",
        height: "644px"
    }
});
import React from "react";
import {useEffect} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {IRPStore} from "../../../app/rp_reducer";
import {gtmApplicationPutAside} from "../../../tracking/google_tag_manager/gtm_application_put_aside";
import {getSentLeadFormValuesFromStorage} from "../../utils/lead/sent_lead_form_values";
import {ApplicationGoodbyeContent, IApplicationGoodbyeContentProps} from "./ApplicationGoodbyeContent";

interface IProps extends IApplicationGoodbyeContentProps {}

export function ApplicationGoodbyeContentModal(props: IProps) {
    const data = useSelector((state: IRPStore) => state.application[props.storeHash]);

    useEffect(() => {
        const sentLeadFormValues = getSentLeadFormValuesFromStorage();

        const areFormValuesAvailable =
            sentLeadFormValues && Boolean(sentLeadFormValues.name) && Boolean(sentLeadFormValues.email) && Boolean(sentLeadFormValues.phone);

        if (data && areFormValuesAvailable) {
            gtmApplicationPutAside(data.vendor?.detail, data.offer?.detail);
        }
    }, []);

    return <ApplicationGoodbyeContent {...props} className={wrapperStyle} />;
}

const wrapperStyle = css({
    md: {
        width: "896px",
        height: "644px"
    }
});
